import { render } from "./DeviceSettingsArchiveBefore.vue?vue&type=template&id=7077772d"
import script from "./DeviceSettingsArchiveBefore.vue?vue&type=script&lang=js"
export * from "./DeviceSettingsArchiveBefore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__